document.addEventListener('variant:change', function(event) {
    let variant = event.detail.variant;
    
    const finalSaleInput = document.querySelector('[data-final-sale-input]');
    
    if (!finalSaleInput) { return }

    const finalSaleJSON = JSON.parse(finalSaleInput.getAttribute('data-final-sale-input'))
    const variantFinalSaleCode = finalSaleJSON[`${variant.id}`]
    
    if (variantFinalSaleCode === '-') {
        finalSaleInput.name = ''
    } else {
        finalSaleInput.name = `properties[Final Sale]`
    }
});